// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","icons":"styles_icons__LGrwM","label":"styles_label__XYfp6","rot":"styles_rot__xPLLG"};